import React from 'react';
import { graphql } from 'gatsby';

import Layout from '../components/layout';
import LinkBox from '../components/link-box';
import SEO from '../components/seo';

export const query = graphql`
  query ($category: String) {
    allEpisodesJson(limit: 2000, filter: { categories: { in: [$category] } }) {
      totalCount
      edges {
        node {
          id
          guest
          fields {
            slug
          }
        }
      }
    }
  }
`;

const Category = ({ pageContext, data }) => {
  const { category } = pageContext;
  const { edges, totalCount } = data.allEpisodesJson;
  const categoryHeader = `${totalCount} episode${
    totalCount === 1 ? '' : 's'
  } categorized with "${category.replace(/^\w+_/, '')}"`;

  return (
    <Layout>
      <SEO title={`#${category.replace(/^\w+_/, '')}`} />
      <div>
        <h3 className="mt-20 mb-5">{categoryHeader}</h3>
        <ul className="flex flex-wrap gap-2 -ml-1 md:gap-4 mt-10 mb-20">
          {edges.map(
            ({
              node: {
                id,
                guest,
                fields: { slug },
              },
            }) => {
              return (
                <li key={slug} className="mx-1 list-none">
                  <LinkBox href={`/episodes/${slug}`}>
                    {id} - {guest.replace(' | ', ', ')}
                  </LinkBox>
                </li>
              );
            }
          )}
        </ul>
        <LinkBox href={`/categories/`}>← All categories</LinkBox>
      </div>
    </Layout>
  );
};

export default Category;
